import React from 'react';
import moment from 'moment';
import { Alert, Modal } from 'react-bootstrap';
import ServicesContext from '../../contexts/ServicesContext';
import { useAuth } from '../../contexts/AuthContext';
import { strings } from '../../resources/strings';
import { ReportJobQueue } from '../../models/ReportJobQueue';
import { OrderType } from '../../enums/OrderType';
import { ProfileType } from '../../enums/ProfileType';
import { Button } from '../../common-components/Button/Button';
import { WaitingIcon } from '../../common-components/WaitingIcon/WaitingIcon';
import { ReportJobQueueCard } from './ReportJobQueueCard/ReportJobQueueCard';
import { FooterContent } from './styles';

interface IReportJobQueueListModalProps {
  visible: boolean;
  onClose: () => void;
}

export const ReportJobQueueListModal: React.FC<IReportJobQueueListModalProps> = ({
  visible,
  onClose
}) => {

  const { session } = useAuth();
  const [reportJobQueueList, setReportJobQueueList] = React.useState<ReportJobQueue[]>([]);
  const [loading, setLoading] = React.useState(false);

  const {
    toastService,
    alertService,
    getReportJobQueueFilteredListService,
    cancelReportJobQueueService
  } = React.useContext(ServicesContext);

  React.useEffect(() => {
    if (visible) {
      getReportJobQueueFilteredList();
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <Modal
      show={visible}
      onHide={() => onClose()}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton style={{ height: '50px' }}>
        <Modal.Title>
          Lista de Relatórios
        </Modal.Title>
      </Modal.Header>

      <Modal.Body id='reportJobQueueListModalBody' style={{ maxHeight: '80vh', overflowY: 'auto' }}>
        {loading ? <WaitingIcon /> : (
          <>
            {reportJobQueueList.length == 0 ? <Alert variant='info'>Nenhum relatório.</Alert> : null}
            {reportJobQueueList.map(reportJobQueue => {
              return (
                <ReportJobQueueCard reportJobQueue={reportJobQueue} key={`report-job-queue-${reportJobQueue.id}`} cancel={() => cancelReportJobQueue(reportJobQueue)} />
              )
            })}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <FooterContent>
          <Button text='Atualizar' click={getReportJobQueueFilteredList}/>
        </FooterContent>
      </Modal.Footer>
    </Modal>
  );

  function getReportJobQueueFilteredList() {
    setLoading(true);
    const yesterday = moment().subtract(1, 'day').format('YYYY-MM-DD');
    getReportJobQueueFilteredListService.handle({
      userId: session?.user?.profileType == ProfileType.Admin ? null : session?.user?.id,
      startDate: yesterday,
      shouldPaginate: false,
      currentPage: 1,
      pageSize: 0,
      orderType: OrderType.Descending,
    })
      .then(result => {
        setReportJobQueueList(result?.value?.list || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toastService.warning(strings.OpsSomethingWrongGettingTheData);
      });
  }

  function cancelReportJobQueue(reportJobQueue: ReportJobQueue) {
    alertService.confirm('Deseja realmente cancelar?').then((confirmResult) => {
      if (confirmResult.isConfirmed) {
        cancelReportJobQueueService.handle({
          id: reportJobQueue.id,
          userId: session?.user?.id || 0,
        }).then(result => {
          if (result?.value?.result) {
            getReportJobQueueFilteredList();
          } else {
            toastService.error(result?.value?.message || 'Não foi possível cancelar!');
          }
        }).catch(() => {
          toastService.error(strings.OpsSomethingWrongSendTheData);
        });
      }
    });
  }
}